<template>
  <div class="d-flex justify-start align-center" :class="[oneLined == 1 ? 'flex-row' : 'flex-column']">
    <!-- Tarif de base, possiblement majoré -->
    <TarificationSolo v-if="course_solo" :tarifs="tarifs" :course="course"></TarificationSolo>
    <TarificationEquipe v-else :tarifs="tarifs" :course="course" :oneLined="oneLined"></TarificationEquipe>



    <!-- Modal du détail des tarifs, si il y a des majorations ou plusieurs tarifs -->
    <v-dialog v-if="tarifs.has_upcoming_majorations() || tarifs.list.length > 1" v-model="showDialog" width="500"
      max-width="100%" scroll-strategy="none">
      <template v-slot:activator="{ props }">
        <SportipsButton @onClick="showDialog = true" v-bind="props" icon="mdi-information-outline" size="sm">Détails
          tarif
        </SportipsButton>


      </template>

      <v-card>
        <v-card-text>
          <TarifItem class="tarif_course_item mb-2 bg-grey_1 px-2 py-1 rounded bordered" v-for="tarif in tarifs.list"
            :key="tarif.id" :tarif="tarif"></TarifItem>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import TarifItem from "@/components/Home/Courses/Tarif_Item.vue";
import TarificationSolo from "@/components/Home/Courses/Tarifs/Tarification_Solo.vue";
import TarificationEquipe from "@/components/Home/Courses/Tarifs/Tarification_Equipe.vue";
export default {
  props: ["tarifs", "course", "all_courses", "oneLined", "withoutPerPerson"],
  components: { TarifItem, TarificationSolo, TarificationEquipe },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    get_default_tarif_on_home() {
      const all_courses = this.mainStore.module.courses.list;
      const prix = this.tarifs.get_default_tarif_on_home(all_courses);
      if (prix == 0) {
        return "Gratuit";
      }
      return prix + "€";
    },
    course_solo() {
      return this.course.is_solo();
    },

  },
};
</script>

<style lang="scss" scoped></style>